export default function useRoom(roomCode: string | null | undefined) {
	const roomCategories = {
		H: 'Habitación accesible',
		I: 'Habitación económica',
		B: 'Habitación de negocios',
		G: 'Habitación confort',
		D: 'Habitación de lujo',
		X: 'Dúplex',
		E: 'Habitación ejecutiva',
		C: 'Suite ejecutiva',
		F: 'Habitación familiar',
		S: 'Junior Suite/Mini Suite',
		P: 'Penthouse',
		R: 'Apartamento residencial',
		M: 'Estándar',
		L: 'Estudio',
		A: 'Superior',
		V: 'Villa',
	}

	const bedTypes = {
		D: 'Doble',
		K: 'King size',
		P: 'Sofá cama',
		Q: 'Queen size',
		S: 'Sencilla',
		T: 'Twin',
		W: 'Cama de agua',
		'*': 'El tipo de cama puede variar',
	}

	// La segunda posición es un dígito o «*» (no se sabe cuántas camas); con otra cosa
	// no es un código de habitación y no se intenta traducir.
	if (roomCode && roomCode.length === 3 && /^[\d*]$/.test(roomCode[1])) {
		const roomCategory: string | undefined =
			roomCategories[roomCode.slice(0, 1) as keyof typeof roomCategories]
		const bedAmount = roomCode.slice(1, 2)
		const bedCode = roomCode.slice(2, 3)
		const bedType: string | undefined =
			bedTypes[bedCode as keyof typeof bedTypes]

		const beds =
			bedAmount === '*' ? null
			: bedAmount === '1' ? '1 cama'
			: `${bedAmount} camas`
		const bedDetail =
			bedCode === '*' ?
				beds ? `${beds}, tipo de cama variable`
				:	bedType
			:	[beds, bedType].filter(Boolean).join(' ')

		return {
			formatted:
				[roomCategory, bedDetail].filter(Boolean).join(' - ') || undefined,
			roomCategory,
			bedAmount,
			bedType,
		}
	}

	return {}
}
